import { render, staticRenderFns } from "./GlowImage.vue?vue&type=template&id=881e9648&scoped=true&"
import script from "./GlowImage.vue?vue&type=script&lang=js&"
export * from "./GlowImage.vue?vue&type=script&lang=js&"
import style0 from "./GlowImage.vue?vue&type=style&index=0&id=881e9648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881e9648",
  null
  
)

export default component.exports